import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsx as t } from "react/jsx-runtime";
import a from "styled-components";
import { withVDSManager as e } from "@vds-core/utilities";
import i from "./PaginationControls.js";
import n from "./PaginationNumbers.js";
var c = a.nav.withConfig({
    displayName: "StyledNav",
    componentId: "VDS__sc-148xq6w-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  &:hover {\n    outline: none;\n  }\n"])), "288px"),
  o = a.ul.withConfig({
    displayName: "StyledList",
    componentId: "VDS__sc-148xq6w-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  white-space: nowrap;\n  list-style-type: none;\n"]))),
  r = function r(a) {
    var e = a["data-analyticstrack"],
      r = a["data-track"],
      s = a["data-track-ignore"],
      l = a["data-clickstream"],
      d = a["data-sitecat-cta"],
      g = a["data-sitecat-datatrack"],
      m = a["data-sitecat-position"],
      p = a["data-sitecat-level"],
      f = a.total,
      u = Object.assign({}, a);
    return t(c, {
      id: a.id,
      tabIndex: -1,
      "aria-label": "Pagination",
      onClick: function onClick(t) {
        "click" === t.type && t.currentTarget.blur();
      },
      "data-analyticstrack": e,
      "data-track": r,
      "data-track-ignore": s,
      "data-clickstream": l,
      children: t(o, {
        children: t(i, Object.assign({
          total: f,
          dataTrack: g,
          position: m,
          level: p,
          cta: d
        }, u, {
          children: t(n, Object.assign({
            selectPage: a.selectPage,
            selectedPage: a.selectedPage,
            total: f
          }, u))
        }))
      })
    });
  };
r.defaultProps = {
  total: 20,
  selectedPage: 10,
  surface: "light"
};
var s = e(r);
export { s as default };